import { render, staticRenderFns } from "./bookingWorkspace.vue?vue&type=template&id=42413867&scoped=true&"
import script from "./bookingWorkspace.vue?vue&type=script&lang=js&"
export * from "./bookingWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./bookingWorkspace.vue?vue&type=style&index=0&id=42413867&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42413867",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42413867')) {
      api.createRecord('42413867', component.options)
    } else {
      api.reload('42413867', component.options)
    }
    module.hot.accept("./bookingWorkspace.vue?vue&type=template&id=42413867&scoped=true&", function () {
      api.rerender('42413867', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/components/booking/bookingWorkspace.vue"
export default component.exports